import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { connect } from 'react-redux'
import * as colors from '../../../../../assets/js/colors'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { Cnpj, ThreeDots, CustomDropdown, Badge } from '../../../../../components'
import ModalApontamentoFaltaManual from './ModalApontamentoFaltaManual/ModalApontamentoFaltaManual'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useFaltasManualPorRota, { LOAD_MESSAGE } from './FaltasManualPorRotaHook'

function FaltasManualPorRota({ dispatch, selectedPicking, missing_products, missing_reasons }) {
  const { state, localDispatch } = useFaltasManualPorRota()

  useEffect(() => {
    localDispatch.onInit(missing_products, missing_reasons)
  }, [missing_products])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE_MISSINGS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveFaltasSeparacaoManual(
          localDispatch.getFalta(state.entregas),
          selectedPicking.id,
        )
        break

      case LOAD_MESSAGE.SAVE_MISSINGS_SUCCESS:
        dispatch(hideLoadingBox())
        localDispatch.onModalClose()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <div style={{ textAlign: 'left' }}>
      <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
      <InputText
        type="search"
        onInput={e => localDispatch.onGlobalFilterChange(e.target.value)}
        placeholder="Pesquisar . . ."
        size="50"
      />
    </div>
  )

  return (
    <React.Fragment>
      <div style={{ padding: 15, paddingLeft: 0, width: 150 }}>
        <CustomDropdown
          optionLabel="name"
          options={state.routes}
          value={state.selectedRoute}
          label="Placa do Veiculo :"
          filter={true}
          onChange={value => localDispatch.onRouteChange(value)}
        />
      </div>
      <DataTable
        value={state.entregas}
        paginator={true}
        rows={10}
        header={header}
        globalFilter={state.globalFilter}
      >
        <Column
          header="Falta"
          style={tableCellCentered(80)}
          body={entrega => {
            return entrega.has_missing_product ? (
              <Badge color={colors.error}>Sim</Badge>
            ) : (
              <Badge color={colors.azul}>Não</Badge>
            )
          }}
        />
        <Column field="nomeFantasia" header="Nome Fantasia" />
        <Column field="cidade" header="Cidade" />
        <Column field="bairro" header="Bairro" />
        <Column
          field="cnpj"
          header="CNPJ"
          style={tableCellCentered(180)}
          body={entrega => <Cnpj>{entrega.cnpj}</Cnpj>}
        />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={entrega => (
            <ThreeDots
              items={['Faltas']}
              onClick={item => localDispatch.onMenuItemClicked(entrega)}
            />
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
      {state.modal.show ? (
        <ModalApontamentoFaltaManual
          show={state.modal.show}
          onModalClose={localDispatch.onModalClose}
          onModalSave={localDispatch.onModalSave}
          data={state.modal.data}
        />
      ) : null}
    </React.Fragment>
  )
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(FaltasManualPorRota)
